import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入自定义css
import './assets/css/common.scss'
import vueXlsxTable from 'vue-xlsx-table'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vueXlsxTable, { rABS: false })

new Vue({
  render: h => h(App),router
}).$mount('#app')
